<template lang="pug">
.row.without-margin
    .col-12
        .row.alerta
            .col-1.center.without-padding
                i(
                    :class='alerta.areaMonitorada ? getIcone() : "mdi mdi-alert-circle warning"'
                )
            .col-11.info
                .row
                    h5.nome {{ alerta.areaMonitorada ? alerta.areaMonitorada.territorio.nome : alerta.territorio.nome }}
                        span.qtd-alertas(v-if='totalAlertasSocioambiental > 0') {{ totalAlertasSocioambiental }} restrições
                .row(v-if='$route.name === "Inicio"')
                    .col-12
                        h6 Área monitorada {{ alerta.areaMonitorada ? alerta.areaMonitorada.id : alerta.id }}
                .row
                    .col-12
                        h6.data {{ dataSocioambiental }}
                .row
                    .col-12
                        h6.saiba-mais(
                            @click='goToAreaMonitorada(alerta.areaMonitorada ? alerta.areaMonitorada.id : alerta.id)'
                        )
                            | Saiba mais
</template>

<script>
import { ALERT_ICONS } from './../utils/helpers/icon-mapper';
import Velocity from 'velocity-animate';
import dateUtil from './../utils/date';

import AlertaService from '@/services/AlertaService';

export default {
    name: 'Alerta',
    props: {
        alerta: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            totalAlertasSocioambiental: 0,
            dataSocioambiental: '',
            ativo: false
        };
    },
    computed: {
        dataCalculada() {
            return dateUtil.dateDiff(
                new Date(),
                new Date(this.alerta.dataCadastro)
            );
        }
    },
    created() {
        if (this.alerta.tipoMonitoramento) {
            this.buscarAlertaSocioambiental();
        }
    },
    methods: {
        goToAreaMonitorada(idAreaMonitorada) {
            this.$router.push({
                name: 'AreaMonitorada',
                params: { idAreaMonitorada: idAreaMonitorada }
            });
        },

        showDescricao() {
            this.ativo = !this.ativo;
        },
        getIcone() {
            return ALERT_ICONS[this.alerta.tipo.nivel.id];
        },
        leave(el, done) {
            var delay = 0;
            setTimeout(() => {
                Velocity(
                    el,
                    {
                        'padding-top': '0px',
                        'padding-bottom': '0px',
                        height: '0px',
                        'min-height': '0px',
                        opacity: 0
                    },
                    { duration: 200, complete: done }
                );
            }, delay);
        },
        enter(el, done) {
            var delay = 0;
            setTimeout(() => {
                Velocity(el, { opacity: 1 }, { duration: 200, complete: done });
            }, delay);
        },
        buscarAlertaSocioambiental() {
            const dataCadastroInicial = new Date();
            dataCadastroInicial.setDate(dataCadastroInicial.getDate() - 90);

            AlertaService.findAlertas(
                this.alerta.id,
                {
                    codigoTipoOperacao: 'INCLUSAO',
                    dataCadastroInicial,
                    dataCadastroFinal: new Date()
                },
                { paginaAtual: 0, tamPagina: 99999 }
            ).then(({ data }) => {
                const alertas = data.alertas;
                this.totalAlertasSocioambiental = data.totalItens;

                let dataString = alertas[0].dataCadastro.split('/');
                let dataSocioambiental = new Date(
                    dataString[2],
                    dataString[1] - 1,
                    dataString[0]
                );
                alertas.forEach(({ dataCadastro }) => {
                    dataString = dataCadastro.split('/');
                    const newDate = new Date(
                        dataString[2],
                        dataString[1] - 1,
                        dataString[0]
                    );

                    if (newDate > dataSocioambiental) {
                        dataSocioambiental = newDate;
                    }
                });
                this.dataSocioambiental = dataSocioambiental.toLocaleDateString(
                    'pt-BR',
                    { timeZone: 'UTC' }
                );
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.nome {
    color: var(--primary-font-color) !important;
}

.box {
    overflow: hidden;
    height: 100% !important;
}

.collapse-icon {
    padding: 0 !important;
}

.descricao {
    background-color: var(--selected-background-color);
    padding: 20px;
    @include border-radius($alert-border-radius);
    border-bottom: 1px solid var(--default-border-color);

    h6 {
        color: var(--primary-font-color) !important;
    }
}

.ativo {
    height: 0;
}

.alerta {
    height: 100%;
    padding: 10px 20px !important;
    margin: 0 !important;
    @include border-radius($alert-border-radius);
    border-bottom: 1px solid var(--default-border-color);
}

i {
    font-size: map-get($font-size, x-large);
}

.data {
    font-style: italic;
    padding: 3px 0;
}

.saiba-mais {
    text-decoration: underline;
    cursor: pointer;
    color: rgb(2, 0, 126);
}

.without-margin {
    margin: 0 !important;
    padding-bottom: 5px;
    .col-12 {
        padding: 0px;
    }
}

.without-padding {
    padding: 0 !important;
}

.area-monitorada {
    text-align: right;
    text-decoration: underline var(--primary);
    h6 {
        margin-top: 15px;
        color: var(--primary) !important;
    }
}

.mdi-open-in-new {
    font-size: map-get($font-size-icon, x-small);
    margin-left: 5px;
}
h4,
h5,
h6 {
    color: var(--secondary-font-color);
}

.qtd-alertas {
    background-color: rgba(172, 0, 0, 0.322);
    color: rgb(77, 0, 0);
    border-radius: 4px;
    margin-left: 8px;
    padding: 0 2px;
    font-size: 10px;
}
</style>
